// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__fUQoq","textBox":"Hero_textBox__ECLn-","title":"Hero_title__cQ+Fp","paragraph":"Hero_paragraph__v3e6h"};